import styled, { css } from 'styled-components';
import { shakeX } from '@widgets/shared/styles/animations';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
export const VisibilityToggle = styled.div `
  display: none;

  ${({ isVisible, isFlex }) => isVisible && css `
    display: block;

    ${isFlex && css `
      display: flex;
    `}
  `}
`;
export const TermsWrapper = styled.div `
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-content: center;

  &.shake {
    -webkit-animation-name: ${shakeX};
    animation-name: ${shakeX};
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: var(1s);
    animation-duration: var(1s);
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  span {
    color: white;
    font-weight: normal;
    text-align: center;
  }

  ${DummyLink} {
    color: var(--primary-light);
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;
export const ModalClose = styled.button `
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  background-color: transparent;
  border:none;
  padding: 0;
  position: absolute;
  top: -3rem;
  right: 0;

  svg {
    height: 1.4rem;
    width: 1.4rem;
  }
`;
